import React from 'react';
import CommunityCounter from './CommunityCounter';

const Footer = () => {
  return (
    <footer className="bg-deep-green p-4 text-center text-sm mt-auto font-lato">
      <p style={{ color: 'var(--color-header-text)' }}>Simple Quran Reader - 100% Free, No Ads, No Sign-up</p>
      <p className="text-xs mt-1 text-light-gold">Data provided by AlQuran.cloud API</p>
      <CommunityCounter />
    </footer>
  );
};

export default Footer;